import { format_price } from 'console/billing/billing-utils';
import { todayToUnix } from 'webui/utils/unixtime';
import { rusDateOnly } from 'webui/utils/time';
export function needShowWarning(sim, autopayment_enabled, account_balance_x100, sim_month_price_x100) {
    // Не подключен автоплатеж симки с баланса
    if (!sim.auto_prolong) {
        return true;
    }
    const not_enough_money = (account_balance_x100 ?? 0) < (sim_month_price_x100 ?? 90_00);
    // недостаточно денег на балансе и не подключен автоплатеж аккаунта
    if (not_enough_money && !autopayment_enabled) {
        return true;
    }
    return false;
}
export function billedSimState(sim, autopayment_enabled, account_balance_x100, sim_month_price_x100, now = todayToUnix()) {
    if (sim.terminated) {
        return {
            status: 'error',
            text: 'Обслуживание прекращено',
        };
    }
    if (sim.paid_until == null) {
        return {
            status: 'error',
            text: 'Не оплачена',
        };
    }
    if (!sim.active) {
        return {
            status: 'error',
            text: 'Заблокирована',
        };
    }
    //Биллинг сим-карт запускается в 9 часов утра по Мск
    //Все сим-карты у нас оплачены до 23:59:59 вчерашнего дня,
    //то есть в промежуток времени с 00:00:00 до 9:20:00 (примерно закончится биллинг),
    //мы показываем оплата просрочена, но ведь это не так!
    //Теперь будем добавлять 10 часов к оплаченному времени, чтобы это избежать
    if (now > sim.paid_until + 10 * 60 * 60) {
        return {
            status: 'error',
            text: 'Оплата просрочена',
        };
    }
    const paid_until_str = `Оплачена до ${rusDateOnly(new Date(sim.paid_until * 1e3))}`;
    if (sim.paid_until - now < 5 * 24 * 60 * 60) {
        if (needShowWarning(sim, autopayment_enabled, account_balance_x100, sim_month_price_x100))
            return {
                status: 'warning',
                text: paid_until_str,
            };
    }
    return {
        status: 'ok',
        text: paid_until_str,
    };
}
export function foreignSimState(balance, balance_value, z3k_config) {
    if (z3k_config) {
        const { gsm_settings } = z3k_config;
        const { notification, threshold } = gsm_settings || {
            notification: null,
            threshold: null,
        };
        if (notification != null) {
            if (balance_value) {
                if (balance_value < Number(threshold)) {
                    return {
                        status: 'error',
                        text: 'Баланс ниже порога',
                    };
                }
                return {
                    status: 'ok',
                    text: `Баланс ${format_price(balance_value)}`,
                };
            }
            else {
                return {
                    status: 'warning',
                    text: 'Не настроено значение порога уведомления о снижении баланса',
                };
            }
        }
    }
    if (balance?.warning) {
        if (balance_value) {
            if (balance_value < (balance?.limit ?? -1_000_000))
                return {
                    status: 'warning',
                    text: 'Баланс ниже порога',
                };
            return {
                status: 'ok',
                text: `Баланс ${format_price(balance_value)}`,
            };
        }
        else {
            return {
                status: 'warning',
                text: 'Не настроено значение порога уведомления о снижении баланса',
            };
        }
    }
    return {
        status: 'ok',
        text: '',
    };
}
